// extracted by mini-css-extract-plugin
export default {"grid":"SMLStatCardsSkeleton_grid__1esJn","card":"SMLStatCardsSkeleton_card__clre8","label":"SMLStatCardsSkeleton_label__IGHki","value":"SMLStatCardsSkeleton_value__YZyli"};